// extracted by mini-css-extract-plugin
module.exports = {"recaptchaContainer":"Recaptcha_recaptchaContainer__45lP9","leftToRight":"Recaptcha_leftToRight__PZqjK"};